import register from '@kpsys/angularjs-register';
import type {FactoryFunction} from 'typings/portaro.fe.types';
import providersModule from '../commons/providers/providers.module';
import {PageableListFactory} from './pageable-list.factory';
import ReaderLoanDataService from './reader-loan.data-service';
import AccountController from './user-account.controller';
import userFinancePanelModule from './user-finance-panel/user-finance-panel.module';
import UserDataService from './user.data-service';
import userRoutes from './user.routes';
import UserService from './user.service';
import RemoteMvsDataService from './remote-mvs.data-service';
import TransactionDataService from './transaction.data-service';
import UserPreferencesDataService from './user-preferences/user-preferences.data-service';
import {UserPreferencesService} from './user-preferences/user-preferences.service';

export default register('portaro.uc.user', [userFinancePanelModule, providersModule])
    .config(userRoutes)
    .factory((PageableListFactory as FactoryFunction).factoryName, PageableListFactory)
    .service(ReaderLoanDataService.serviceName, ReaderLoanDataService)
    .service(UserDataService.serviceName, UserDataService)
    .service(UserService.serviceName, UserService)
    .service(RemoteMvsDataService.serviceName, RemoteMvsDataService)
    .service(TransactionDataService.serviceName, TransactionDataService)
    .service(UserPreferencesDataService.serviceName,UserPreferencesDataService)
    .service(UserPreferencesService.serviceName,UserPreferencesService)
    .controller(AccountController.controllerName, AccountController)
    .name();
